/* =========================================================
   Cellfy · BGS 2026 — Hero (vídeo de fundo + contagem)
   ========================================================= */
(function () {
  'use strict';

  function initCountdown(section) {
    if (!section || section.dataset.cbgsCountdownInit === 'true') return;
    section.dataset.cbgsCountdownInit = 'true';

    var wrap = section.querySelector('[data-cbgs-countdown]');
    if (!wrap) return;

    var targetRaw = section.dataset.eventoData;
    var target = targetRaw ? new Date(targetRaw) : null;
    if (!target || isNaN(target.getTime())) return;

    var elDays = section.querySelector('[data-cbgs-days]');
    var elHours = section.querySelector('[data-cbgs-hours]');
    var elMinutes = section.querySelector('[data-cbgs-minutes]');
    var elSeconds = section.querySelector('[data-cbgs-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target.getTime() - Date.now();

      if (diff <= 0) {
        wrap.innerHTML = '<div class="cbgs-countdown--ended">O evento começou!</div>';
        clearInterval(timer);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (elDays) elDays.textContent = pad(days);
      if (elHours) elHours.textContent = pad(hours);
      if (elMinutes) elMinutes.textContent = pad(minutes);
      if (elSeconds) elSeconds.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* Pausa o vídeo quando a aba não está visível (economiza recursos) */
  function initVideoPause(section) {
    var video = section.querySelector('.cbgs-hero__bg-video');
    if (!video) return;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        video.pause();
      } else {
        var p = video.play();
        if (p !== undefined) p.catch(function () {});
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.cbgs-hero-video').forEach(function (section) {
      initCountdown(section);
      initVideoPause(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cbgs-hero-video');
    if (section) {
      initCountdown(section);
      initVideoPause(section);
    }
  });
})();